import us from '../../../defines';
import { hexColortoRGB, toHexColor } from '../../../lib/utility/helpers';
import { setIconState } from '../../../toolbar';
import ColorPickerControl from './color-picker-control';
import {translate} from 'shared/services/I18nService';
const $t = translate.scope('uScope.extensions.annotations.color-picker');

export default function ColorPicker (uScope) {
  let jPanel;
  let jColorPickerContainer;
  let jColorPickerBar;
  let control;
  let jColorPickerGrid;

  const isVisible = () => jPanel.is(':visible');

  this.toggle = function (color) {
    const visible = isVisible();
    if (!visible) {
      jPanel.dialog('open');
      position();
      set(color);
    } else {
      jPanel.dialog('close');
    }
    return !visible; // invert since state is reversed now.
  };

  function show (color) {
    jPanel.dialog('open');
    set(color);
  }

  const position = function () {
    const options = { width: getGridWidth() + 40 };
    const target = $('.us-color-picker-target');
    if (target.length > 0) {
      options.position = {
        my: 'top',
        at: 'bottom',
        of: target
      };
    }
    jPanel.dialog(options);
  };

  const set = function (color) {
    if (isVisible()) {
      let curColorHex = '#' + toHexColor(color);
      control.selectByColor(curColorHex);
      jColorPickerBar.css({'background-color': curColorHex});
    }
  };

  const getGridWidth = function () {
    return jColorPickerGrid.width();
  };

  const init = function () {
    jPanel = $('<div/>', {
      'id': us.idCLRPICKPANEL,
      'class': us.clsPANEL,
      'title': $t('select-color')
    });
    // add the div of color squares to the panel
    jColorPickerContainer = $('<div id=' + us.idCLRPICKDIV + '></div>');
    jPanel.append(jColorPickerContainer);

    jPanel.dialog({
      autoOpen: false,
      closeOnEscape: false,
      modal: true,
      draggable: true,
      resizable: false,
      stack: true,
      appendTo: 'body',
      position: ['center', 'bottom'],
      dialogClass: 'uscope-dialog dialogMover',
      closeText: $t('close'),
      buttons: [{
        text: $t('ok'),
        click: function () {
          setIconState($('.' + us.APANNOTCOLOR), us.APANNOTCOLOR, 'enabled');
          $(this).dialog('close');
        }
      }, {
        text: $t('cancel'),
        click: function () {
          setIconState($('.' + us.APANNOTCOLOR), us.APANNOTCOLOR, 'enabled');
          $(this).dialog('close');
        }
      }]
    });

    control = new ColorPickerControl(jColorPickerContainer, {
      columns: 13,
      click: function (clr) {
        // I feel like injecting the plugin service on to the uScope instance is a bit hacky.
        // TODO: Find some other way of changing the current region's selected color.
        const annotationsService = uScope.pluginService.getInstance(uScope.getThisImage(), 'us:annotations:service');
        annotationsService && annotationsService.setSelColor(hexColortoRGB(clr));
        jPanel.dialog('close');
        setIconState($('.' + us.APANNOTCOLOR), us.APANNOTCOLOR, 'enabled');
      }
    });

    jColorPickerGrid = $('.' + us.clsCLRPICKGRID);
    jColorPickerBar = $('<div/>', {'id': us.idCLRPCKBAR, 'width': getGridWidth() - 5, 'height': 14});

    // and add a color bar div to display the selected color
    jPanel.append(jColorPickerBar);

    // bah
    uScope.events.on('us:color-picker:show-color-picker', show);
  };

  init();
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/color-picker/color-picker.js